import { useEffect, useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { RiCoinsLine } from 'react-icons/ri';
import SlidingModal from '../../SlidingModal';
import Image from 'next/image';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
import { networkNames } from '@shared/types/executor';
import { IoMdCheckmark } from 'react-icons/io';
import { useSession } from '@/contexts/LitSessionProvider';
import { useOrderHistory } from '@/hooks/db/useOrderHistory';
import CustomDialog from '@/components/ui/customDialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { ImageWithFallback } from '@/components/shared/NextImageFallback';
import { isNativeTokenAddress } from '@/lib/asset/nativeAddressHelper';
export default function TokenFilter({
  tokenFilter,
  setTokenFilter,
  isMobile = true
}) {
  const {
    PKP
  } = useSession();
  const {
    data: mainOrderHistory,
    isLoading: orderHistoryLoading
  } = useOrderHistory({
    cloudWallet: PKP?.additionalEthAddress,
    solanaAddress: PKP?.solanaAddress
  });
  const [isTokenModalOpen, setIsTokenModalOpen] = useState(false);
  const [tokenList, setTokenList] = useState<any>([]);
  const [openModal, setOpenModal] = useState(false);
  function toggleOpenModal() {
    setOpenModal(!openModal);
  }
  function toggleTokenModal() {
    setIsTokenModalOpen(!isTokenModalOpen);
  }
  function handleSelectToken(token: any) {
    setTokenFilter(token);
    toggleTokenModal();
    setOpenModal(false);
  }
  function extractUniqueTokens(data) {
    const uniqueTokensMap = new Map();
    data.forEach(item => {
      if (item.token_address) {
        const key = `${item.token_address}-${item.chain_id}`;
        if (!uniqueTokensMap.has(key)) {
          uniqueTokensMap.set(key, {
            network: item.chain_id,
            token_address: item.token_address,
            logo_url: item.token_metadata.image_thumb_url,
            symbol: item.token_metadata.symbol
          });
        }
      }
      if (item.token_prices && item.token_prices.tokensIn) {
        item.token_prices.tokensIn.forEach(token => {
          const key = `${token.contract_address}-${token.network}`;
          if (!uniqueTokensMap.has(key)) {
            uniqueTokensMap.set(key, {
              network: token.network,
              token_address: token.contract_address,
              logo_url: token.logo_url,
              symbol: token.contract_ticker_symbol
            });
          }
        });
      }
      if (item.token_prices && item.token_prices.tokensOut) {
        item.token_prices.tokensOut.forEach(token => {
          const key = `${token.contract_address}-${token.network}`;
          if (!uniqueTokensMap.has(key)) {
            uniqueTokensMap.set(key, {
              network: token.network,
              token_address: token.contract_address,
              logo_url: token.logo_url,
              symbol: token.contract_ticker_symbol
            });
          }
        });
      }
    });
    const uniqueTokens = Array.from(uniqueTokensMap.values());
    console.log('uniqueTokens', uniqueTokens);
    return uniqueTokens;
  }
  useEffect(() => {
    if (mainOrderHistory) {
      const filteredTokens = extractUniqueTokens(mainOrderHistory?.data);
      setTokenList(filteredTokens);
    }
  }, [mainOrderHistory]);
  const ModalContent = () => {
    return <>
        {orderHistoryLoading && <div className='px-4 mt-4 text-genius-cream/50 text-[14px]'>Loading...</div>}
        <div>
          <div onClick={() => handleSelectToken(null)} className='px-4 py-2 items-center cursor-pointer'>
            <div className='flex gap-x-5 items-center relative '>
              <div className='relative w-fit left-0 flex items-center'>
                <Image src={'/static/genius.png'} width={100} height={100} alt='network-logo' className='w-[20px] h-[20px] mr-4 rounded-full' data-sentry-element="Image" data-sentry-source-file="TokenFilter.tsx" />{' '}
                All
              </div>
            </div>
          </div>
          <ScrollArea className='h-[500px] pb-[100px]' data-sentry-element="ScrollArea" data-sentry-source-file="TokenFilter.tsx">
            {tokenList && tokenList?.map((token: any, index) => {
            {
              index;
            }
            return <div onClick={() => handleSelectToken(token)} key={index} className='px-4 py-2 items-center cursor-pointer'>
                    <div className='flex gap-x-5 items-center relative '>
                      <div className='relative w-fit left-0 flex items-center'>
                        <ImageWithFallback src={isNativeTokenAddress(token?.token_address) ? getNetworkLogo(token?.network) : token.logo_url || getNetworkLogo(token.network)} width={100} height={100} alt='network-logo' className='w-[29px] h-[26px] right-0 rounded-full' />
                        <ImageWithFallback src={getNetworkLogo(token.network)} width={100} height={100} alt='network-logo' className='w-[10px] h-[10px] absolute bottom-[0px] left-5' />
                      </div>
                      <div className='flex items-center w-full h-[35px]'>
                        <div>
                          <p className='text-[14px] text-genius-cream'>{token.symbol}</p>
                          <p className='text-[10px] text-genius-cream/50'>
                            on {networkNames[token.network]}
                          </p>
                        </div>
                        {tokenFilter && tokenFilter.token_address === token.token_address && tokenFilter.network === token.network && <IoMdCheckmark className='ml-4' />}
                      </div>
                    </div>
                  </div>;
          })}
          </ScrollArea>
        </div>
      </>;
  };
  const ModalTrigger = () => {
    return <>
        <div onClick={() => isMobile ? toggleTokenModal() : toggleOpenModal()} className='capitalize rounded-lg w-fit px-2 h-[37px] border-genius-blue border-[1px] float-right text-[14px] flex items-center cursor-pointer'>
          {tokenFilter && tokenFilter?.token_address !== null ? <div className='flex items-center relative '>
              <div className='relative w-fit flex items-center'>
                <ImageWithFallback src={tokenFilter.logo_url || getNetworkLogo(tokenFilter.network)} width={100} height={100} alt='network-logo' className='w-[25px] h-[20px] right-0 rounded-full' />
                <ImageWithFallback src={getNetworkLogo(tokenFilter.network)} width={100} height={100} alt='network-logo' className='w-[10px] h-[10px] absolute bottom-[0px] left-3 rounded-full' />
              </div>
              <div className='items-center w-full'>
                <p className='text-[14px] text-genius-cream ml-4'>{tokenFilter.symbol}</p>
              </div>
            </div> : 'All'}{' '}
          <MdKeyboardArrowDown className='ml-2' data-sentry-element="MdKeyboardArrowDown" data-sentry-source-file="TokenFilter.tsx" />
        </div>
      </>;
  };
  return <div className='flex justify-between w-full' data-sentry-component="TokenFilter" data-sentry-source-file="TokenFilter.tsx">
      <div className='w-2/4 flex itemsn-center'>
        <p className='text-genius-cream text-[16px] flex items-center'>
          <RiCoinsLine className='w-[22px] h-[22px] ' data-sentry-element="RiCoinsLine" data-sentry-source-file="TokenFilter.tsx" />
          <span className='ml-2 text-genius-cream/50'>Token</span>
        </p>
      </div>
      <div className='w-2/4'>
        {!isMobile ? <>
            <ModalTrigger />
            <CustomDialog hideClose={true} toggleModal={toggleOpenModal} isOpen={openModal} className={'h-[500px] w-[400px] px-0'}>
              <ModalContent />
            </CustomDialog>
          </> : <>
            <ModalTrigger />
            <SlidingModal isOpen={isTokenModalOpen} onClose={toggleTokenModal}>
              <ModalContent />
            </SlidingModal>
          </>}
      </div>
    </div>;
}